import { TCommunication } from "~/types";
import { baseService } from "../base";
import { PaginationParams, PaginationResponse } from "../type";
import { CreateCommunicationParams } from "./communication.types";

export interface BatSignalResponse {
  staffId: string;
  staffName: string;
  status: 'PENDING' | 'ACCEPTED' | 'DECLINED' | 'EXPIRED';
  respondedAt: string | null;
  positionName: string;
}

export interface BatSignalResponsesData {
  pending: number;
  accepted: number;
  declined: number;
  expired: number;
  responses: BatSignalResponse[];
}

export const communicationServices = {
  getCommunicationHistory: async (params?: PaginationParams) => {
    const { data } = await baseService.get<PaginationResponse<TCommunication>>(
      "/communications",
      {
        params,
      }
    );
    return data;
  },
  createCommunication: async (data: CreateCommunicationParams) => {
    const response = await baseService.post<TCommunication>(
      "/communications",
      data
    );
    return response.data;
  },
  getBatSignalResponses: async (serviceTicketId: string) => {
    const { data } = await baseService.get<BatSignalResponsesData>(
      `/communications/bat-signal/responses/${serviceTicketId}`
    );
    return data;
  },
};
